import {
  DEVICE_SET_INFO,
  DEVICE_SET_TARGET,
  DEVICE_SET_SECONDARY_TARGET,
  DEVICE_SET_RELEASE_VERSION,
} from '../constants/actionTypes';

const initialState = {
  devices: {},
  target: null,
  secondaryTarget: null,
  releaseVersion: [],
};

const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEVICE_SET_RELEASE_VERSION: {
      return {
        ...state,
        releaseVersion: action.releaseVersion,
      };
    }
    case DEVICE_SET_TARGET:
      return {
        ...state,
        target: action.target,
      };
    case DEVICE_SET_SECONDARY_TARGET:
      return {
        ...state,
        secondaryTarget: action.target,
      };
    case DEVICE_SET_INFO:
      return {
        ...state,
        devices: {
          ...state.devices,
          [action.id]: {
            id: action.id,
            ...action.device,
          },
        },
      };
    default:
      return state;
  }
};

export default deviceReducer;
